import { Button } from '@/design-system/button/button';
import { ComponentProps, useState } from 'react';
import { MetricCard } from './metric-card';
import { ReturnsDrawer } from './returns-drawer/returns-drawer';

type ReturnDrawerTriggerCardProps = {
  cardConfig: ComponentProps<typeof MetricCard>['cardConfig'];
  onOpenDrawer: () => void;
};

export const ReturnDrawerTriggerCard = (props: ReturnDrawerTriggerCardProps) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <Button
        variant="ghost"
        size="none"
        onClick={() => {
          setIsDrawerOpen(true);

          props.onOpenDrawer();
        }}
        className="min-w-[180px] shrink-0 grow basis-0 self-stretch rounded-lg p-0"
      >
        <MetricCard {...props} className="h-full w-full min-w-0" />
      </Button>

      {props.cardConfig.variant === 'RETURN' && (
        <ReturnsDrawer
          isOpen={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          currency={props.cardConfig.currency}
          returnData={props.cardConfig.returnData}
        />
      )}
    </>
  );
};
